import { render, staticRenderFns } from "./account-activation-error-design-form.vue?vue&type=template&id=1197c790"
import script from "./account-activation-error-design-form.vue?vue&type=script&lang=js"
export * from "./account-activation-error-design-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports